<app-auth-wrapper>
  <form [formGroup]="formGroup" (ngSubmit)="submit()" class="row g-3">
    <div class="col-sm-12 mb-2">
      <app-form-input [id]="'username'"
                      [label]="('AUTH.USERNAME'|translate)"
                      [controlName]="'username'"
                      [formGroup]="formGroup"
                      [isRequired]="true"></app-form-input>
    </div>

    <div class="col-sm-12">
      <app-form-input [id]="'password'"
                      [label]="('AUTH.PASSWORD'|translate)"
                      [controlName]="'password'"
                      [formGroup]="formGroup"
                      [type]="'password'"
                      [isRequired]="true"></app-form-input>
    </div>

    <div>
      <a [routerLink]="['/auth/password-forgotten']">{{"AUTH.FORGOTTEN_PASSWORD"|translate}}?</a>
    </div>

    <!-- Submit button -->
    <div class="d-flex justify-content-center">
      <app-mdb-button [text]="'AUTH.LOGIN'"
                      [isSubmit]="true"
                      [loading]="loading"></app-mdb-button>
    </div>

  </form>
</app-auth-wrapper>
